import { render, staticRenderFns } from "./ngo-info-page.html?vue&type=template&id=2718de04&scoped=true&external"
import script from "./ngo-info-page.js?vue&type=script&lang=js&external"
export * from "./ngo-info-page.js?vue&type=script&lang=js&external"
import style0 from "./ngo-info-page.scss?vue&type=style&index=0&id=2718de04&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718de04",
  null
  
)

export default component.exports